// extracted by mini-css-extract-plugin
module.exports = {"SectionCard1":"SectionCard1_SectionCard1__c_v_A"};